module.exports = __webpack_public_path__ + "img/lkl.5321a07b.jpg";